import { injectGlobal } from 'styled-components';
import AboveFoldBackground from './images/bg.png';
import af2Mob from './images/above-the-fold-mobile-new-bg.jpg';
import af2 from './images/above-the-fold-new-bg2.png';
import arrow from './images/arrow.png';
import howCover from './images/how.png';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  :root{
    color-scheme: light;
  }
  html {
    scroll-behavior: smooth;
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    &.ar {
      font-family: 'Droid Arabic Kufi', serif;
    }
    &.dimmable.dimmed {
      position: fixed;
    }
  }

  @media (prefers-color-scheme: dark) {
    #app{
      background-color: #fafafa;
    }
    .ui.menu:not(.vertical) .item>.button {
      span{
        color:#fff
      }
      
    }
  }
  html[native-dark-active]{
  --native-dark-visited-link-color:hsla(0, 100%, 100%, 1);
  --native-dark-bg-color:hsla(0, 0%, 98%, 1);
  --native-dark-link-color:hsla(0, 100%, 100%, 1);
  }

  html[native-dark-active] body{
  --native-dark-font-color:hsla(0, 0%, 0%, 0.68);
  --native-dark-bg-color:hsla(0, 0%, 98%, 1)
  }

  html[native-dark-active] .ui.inverted.button,
  html[native-dark-active] .ui.secondary.inverted.menu a.item,
  html[native-dark-active] .ui.orange.button
  {
    --native-dark-font-color:hsla(0, 100%, 100%, 1);

  }
  
  html[native-dark-active] .ui.orange.button:hover{
    background-color:hsla(0, 100%, 100%, 1);
  }

  html[native-dark-active] .ui.secondary.inverted.menu a.item:hover,
  html[native-dark-active] .ui.inverted.menu .active.item{
    --native-dark-bg-color:hsla(0, 100%, 100%, 0.15);
    --native-dark-visited-link-color:hsla(0, 100%, 100%, 0.15);
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  body.ar {
    .rtl {
      direction: rtl;
    }
  }

  .aboveFold.legacy {
    min-Height: 43rem;
    @media screen and (min-width: 767px) {
      h1.ui.large.header {font-size: 2.5em;}
      h2.ui.medium.header {font-size: 1.5em;}
      background: url(${AboveFoldBackground}) 100% 100%/cover no-repeat scroll;
    }
    @media screen and (max-width: 767px) {
      h1.ui.large.header {font-size: 2em;}
      h2.ui.medium.header {font-size: 1.4em;}
      background: url(${AboveFoldBackground}) 100% 100%/contain no-repeat scroll;
    }
    .homeInput {
      padding-bottom: 4rem !important;
      input{
        border-color: black !important;
      }
    }
  }

  .owl-carousel .owl-stage, .owl-carousel.owl-drag .owl-item {
    -ms-touch-action: pan-y !important;
    touch-action: pan-y !important;
  }

  .aboveFold.offers {
    min-Height: 43rem;
    @media screen and (min-width: 992px) {
      h1.ui.large.header {font-size: 2.5em;}
      h2.ui.medium.header {font-size: 1.5em;}
      background: url(${af2}) 100% 100%/contain no-repeat scroll;
    }
    @media screen and (max-width: 991px) {
      h1.ui.large.header {font-size: 2em;}
      h2.ui.medium.header {font-size: 1.4em;}
      background: url(${af2Mob}) 100% 100%/cover no-repeat scroll;
      .column {
        text-align: center !important;
      }
    }
    .homeInput {
      padding-bottom: 4rem !important;
      input{
        border-color: black !important;
      }
    }
  }

  body.ar .aboveFold {
    .column {
      direction: ltr;
      text-align: right
    }
  }

  .promoBanner{
    @media screen and (min-width: 767px) {
      min-height: 55px !important;
    }
    @media screen and (max-width: 768px) {
      background-position: center !important;
    }
  }

  .howCover{
    min-Height: 20rem;
    background: url(${howCover}) 100% 100%/cover no-repeat scroll;
  }

  .offlineToast{
    background-color: #3b3b3b;
  }


  p,
  label {
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    line-height: 1.5em;
    body.ar & {
      font-family: 'Droid Arabic Kufi', serif;
    }
  }

  .successMessage{
    color: green;
  }

  .compareHead{
    color: #359bff;
    @media screen and (max-width: 767px) {
      text-align:center !important;
    }
  }
  .compareParagraph>p:first-of-type {
    display: inline;
  }
  .ui.table:not(.unstackable) tr.compareRow {
    @media screen and (max-width: 767px) {
      padding-top:0em;
    }
  }
  .ui.table:not(.unstackable) tr.compareRow td {
    @media screen and (max-width: 767px) {
      padding: 1em 2em 1em 2em !important;
    }
  }

  .pullLeft{
    float:left;
    &:lang(ar){
      float:right;
    }
  }
  .pullRight{
    float:right;
    &:lang(ar){
      float:left;
    }
  }
  .textLeft{
    text-align:left;
    &:lang(ar){
      text-align:right;
    }
  }
  .textRight{
    text-align:right;
    &:lang(ar){
      text-align:left;
    }
  }

  .textCentered{
    text-align:center;
    &:lang(ar){
      text-align:left;
    }
  }
  .imageMobile{
    @media screen and (max-width: 767px) {
      max-height: 150px !important;
    }
    @media screen and (min-width: 768px) {
      max-height: 300px !important;
    }
  }
  .hiddenMobile{
    @media screen and (max-width: 767px) {
      display: none !important;
    }
  }
  .hiddenNotMobile{
    @media screen and (min-width: 768px) {
      display: none !important;
    }
  }
  .p0{
    padding:0 !important;
  }
  .owl-nav{
    position: absolute;
    top: 75px !important;
    width: 100%;
    font-size:2em;

    .owl-next{
      position: absolute;
      display:block;
      right:0px;
      background-image: url(${arrow});
      background-repeat: no-repeat;
      width:50px;
      height:50px;
      background-position: center center;
      background-size: contain;
    } 
    .owl-prev{
      position: absolute;
      display:block;
      left:0px;
      background-image: url(${arrow});
      background-repeat: no-repeat;
      width:50px;
      height:50px;
      background-position: center center;
      background-size: contain;
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
    }
  }
  .ptb0{
    padding-top:0 !important;
    padding-bottom:0 !important;
  }
  .prl0{
    padding-right:0 !important;
    padding-left:0 !important;
  }
  .prl10{
    padding-right:10px !important;
    padding-left:10px !important;
  }
  .pb0{
    padding-bottom:0 !important;
  }
  .pt0{
    padding-top:0 !important;
  }
  .mgb10{
    margin-bottom: 10px;
  }
  .mgt10{
    margin-top: 10px !important;
  }
  .mgt0{
    margin-top:0 !important;
  }
  .mgb0{
    margin-bottom:0 !important;
  }
  .mxh80px{
    max-height: 80px;
  }
  .pointer{
    cursor: pointer;
  }
  .height-fix{
    min-height:56vh;
  }
  .mg0a{
    margin: 0 auto !important;
  }

  .minh60{
    min-height: 60vh;
    @media screen and (max-width: 767px) {
      min-height: 0;
    }
  }

  .ui.menu:not(.vertical) .right.menu:lang(ar){margin-left:0 !important; margin-right:auto;}
  .ui.menu .item>i.icon:lang(ar){margin: 0 0.35714286em 0;}
  .ui.menu .ui.dropdown .menu>.item:lang(ar) {text-align:right;}
  .ui.list>.item>i.icon:lang(ar){padding-right:0; padding-left: 0.28571429em;}
  .ui.bulleted.list:lang(ar) :not(.horizontal){margin-left:0 !important; margin-right:1.25rem;}
  .ui.bulleted.not(.horizontal).list :not(.horizontal) .list>.item:lang(ar)::before, .ui.bulleted.list>.item:lang(ar)::before, ul.ui.list li:lang(ar)::before{margin-left:0 !important; margin-right:-1.25rem;}
  .ui.divided.grid:lang(ar):not([class*="vertically divided"])>.column:not(.row), .ui.divided.grid:not([class*="vertically divided"])>.row>.column ::before{box-shadow: 1px 0 0 0 rgba(34,36,38,.15);}
  .ui.divided.grid:lang(ar):not([class*="vertically divided"])>.column:first-child, .ui.divided.grid:not([class*="vertically divided"])>.row>.column:first-child {box-shadow: none;}
  i.outline.icon:lang(ar), i.icon:lang(ar){margin: 0 0 0 0.25rem;}
  .ui.accordion .title .dropdown.icon:lang(ar) {transform: rotate(180deg);}
  .ui.accordion .title.active .dropdown.icon:lang(ar) {transform: rotate(90deg);}
  .ui.items>.item>.image+.content:lang(ar){padding-left:0; padding-right:1.5em;}
  .ui.toggle.checkbox input:checked~.box:after, .ui.toggle.checkbox input:checked~label:after{background: #f8f8f8;}
  .ui.selection.dropdown .menu>.item:lang(ar){text-align:right}
  .owl-carousel, .bx-wrapper:lang(ar) { direction: ltr; }
  .owl-carousel .owl-item:lang(ar) { direction: rtl; }
  .addressDrop .ui.selection.active.dropdown .menu{min-height:34vh;}
  .ui.button:not(.icon)>.icon:not(.button):not(.dropdown){margin:0}
  .ui.message>.icon:lang(ar){margin-right:0;margin-left:0.6em;}
  .ui.floating.dropdown .menu:lang(ar){right:0; left:auto}
  
  
  body.ar {
    *:not(.icon){
      font-family: 'Droid Arabic Kufi', Lato,'Helvetica Neue',Arial,Helvetica,sans-serif; 
      .termsConditionsSection {
        .ui.list .list>.item, .ui.list>.item, ol.ui.list li, ul.ui.list li {
        line-height: 1.5em;
        }
        .ui.list .list>.item>.content, .ui.list>.item>.content {
          line-height: 1.5em;
        }
      }    
    }

    .ui.ordered.list.pullLeft, .ui.ordered.list.pullLeft .list, ol.ui.list.pullLeft, ol.ui.list.pullLeft ol {
      margin-left: 0;
      margin-right: 1.25rem;
    }
    .ui.ordered.list.pullLeft .list>.item:before, .ui.ordered.list.pullLeft>.item:before, ol.ui.list.pullLeft li:before {
      margin-left: 0;
      margin-right: -1.25rem;
    }
    .rewardsAr {
      padding: 0.25em 0.75em .5em 0 !important;
    }

    .ui.header .sub.header {
      line-height: 1.8em;
    }
    .ui.large.header {
      line-height: 2.2em;
    }
  }

  .lite-input input {
    font-size: 0.85em;
    padding: 0.85em !important;
  }
  .lite-input input:focus {
    border-left-color: transparent !important;
  }

  .offers-cart {
    .no-mobile-padding {
      @media screen and (max-width: 767px) {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }

    h1.ui.large.header {
      font-size: 2.5em;
      color: #00b5ad;
      @media screen and (max-width: 767px) {
        font-size: 2em;
      }
    }
    h2.ui.header {
      @media screen and (max-width: 767px) {
        font-size: 1.25em;
      }
    }
    h3 {
      @media screen and (max-width: 767px) {
        font-size: 1.1em;
      }
    }

    .ui.card>.image, .ui.cards>.card>.image {
      background-color: #fff;
      img {
        @media screen and (max-width: 768px) {
          max-height: 200px;
          width: auto;
          margin: auto;
        }
      }
    }
  }

  .qty-cart-btns {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 1136px) and (min-width: 992px) {
      flex-direction: column;
      .button.dropdown {
        margin-right: 0;
        i {
          float: right;
        }
      }
    }
    @media screen and (max-width: 1650px) and (min-width: 1200px) {
      flex-direction: column;
      .button.dropdown {
        margin-right: 0;
        i {
          float: right;
        }
      }
    }
  }

  .MuiStepper-vertical-544 {
    padding-left: 0;
    padding-right: 0;

    .MuiSvgIcon-root-594 {
      width: 0.7em;
      height: 0.7em;
    }

    .MuiStepConnector-vertical-641 {
      padding: 0;
      margin-left: 9px;
    }

    .MuiStepConnector-lineVertical-648 {
      min-height: 9px;
    }
  }

  #credential_picker_container {
    top: 67px !important;
    z-index: 999 !important;
  }
  #credential_picker_iframe {
    z-index: 999 !important;
  }
  #buttonDiv {
    width: 100%
  }
  .zopim, .fb_dialog  {
    z-index: 998 !important;
  }

  .ui.modal.promotions>.close {
    top: 1.0535rem;
    right: 1rem;
    color: rgba(0,0,0,.87);
  }

  .ui.modal.promotions>.content {
    padding: 1rem 0 !important;
  }

  @media only screen and (max-width: 767px) {
    .ui.modal.fullscreen.promotions {
      width: 100% !important;
      margin: 0;
      left: 0 !important;
      right: 0;
    }
  }

  .ui.left.slide.along.sidebar {
    -webkit-transform: translate3d(-100%,0,0);
    -ms-transform: translate3d(-100%,0,0);
    transform: translate3d(-100%,0,0);
  }
  .ui.visible.left.slide.along.sidebar {
    -webkit-transform: translate3d(0,0,0);
    -ms-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
  }

  .share-btn {
    cursor: pointer;
  }
  
  .share-btn:hover:not(:active) {
    opacity: 0.75;
  }
`;



// WEBPACK FOOTER //
// ./app/global-styles.js